import React, { useState, useEffect } from 'react'
import Terrace from './Components/Terrace'
import QuoteSummary from '../../Components/QuoteSummary'

const TerracePage = () => {
  const [quoteData, setQuoteData] = useState(null);

  useEffect(() => {
    // Récupérer les données du devis depuis le localStorage
    const storedQuoteData = localStorage.getItem('quoteData');
    if (storedQuoteData) {
      try {
        const parsedData = JSON.parse(storedQuoteData);
        setQuoteData(parsedData);
        console.log('📦 Données du devis récupérées:', parsedData);
      } catch (error) {
        console.error('Erreur lors du parsing des données du devis:', error);
      }
    }
  }, []);

  return (
    <div>
      <Terrace quoteData={quoteData} />
      <QuoteSummary />
    </div>
  )
}

export default TerracePage